import { Injectable } from '@angular/core';

@Injectable()
export class DialogService {
    alert: (message?: string, title?: string) => Promise<void>;
    confirm: (message?: string, title?: string, details?: string) => Promise<void>;
}
